import { overviewKey } from '../overviewCard';

/** Testid prefix, icons and copy keys for the cash-coverage card. */
export const CASH_COVERAGE = {
    slot: 'cash-coverage',
    icon: 'solar:wallet-money-bold-duotone',
    ctaIcon: 'solar:link-round-bold-duotone',
    keys: {
        title: overviewKey('cashCoverage', 'title'),
        question: overviewKey('cashCoverage', 'question'),
        cash: overviewKey('cashCoverage', 'cash'),
        obligations: overviewKey('cashCoverage', 'obligations'),
        ratio: overviewKey('cashCoverage', 'ratio'),
        emptyBody: overviewKey('cashCoverage', 'emptyBody'),
        emptyCta: overviewKey('cashCoverage', 'emptyCta'),
    },
};
